import { Component } from '@angular/core';
import {
  ActivityInternal,
  ActivityInternalTableComponent
} from 'gung-standard';
import { ColmecActivityInternalViewModalComponent } from '../colmec-activity-internal-view-modal/colmec-activity-internal-view-modal.component';

@Component({
    selector: 'colmec-activity-internal-table',
    templateUrl: './colmec-activity-internal-table.component.html',
    styleUrls: ['./colmec-activity-internal-table.component.scss'],
    standalone: false
})
export class ColmecActivityInternalTableComponent extends ActivityInternalTableComponent {
  openViewModal(item: ActivityInternal) {
    const modalRef = this.modalService.open(ColmecActivityInternalViewModalComponent, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      backdrop: 'static'
    });
    modalRef.componentInstance.data = item;
    modalRef.result.then(
      result => {},
      reason => {
        console.log(`Dismissed ${reason}`);
      }
    );
  }
}
